module.exports = __webpack_public_path__ + "media/backgrounds/willian-justen-de-vasconcellos-ODZiEQDbjbs-unsplash-e9920cbe.jpg";